import React, { useState, useEffect } from 'react'
import Loader from 'react-loader-spinner'

import queryString from 'query-string'

import Layout from '../../components/Layout/Default'

import { Container, Image, Message, MobileMessage, NoPitStop } from './styles'

import api from '../../services/api'

function PitStop(){
  //React States
  const [ loader, setLoader ] = useState(true)
  const [ pitStop, setPitStop ] = useState([{ img: "https://i.imgur.com/HEAEgx2.png" }])

  //Get date in UTC
  async function getDate(){
    const time = new Date().setUTCHours(0,0,0,0)
    return new Date(time).toISOString()
  }

  async function getPitStop(){
    const date = await getDate()
    const params = queryString.stringify({ date })

    const response = await api.get(`/pitstop/?${params}`)
    console.log(response)

    const result = response.data
    setPitStop(result)

    setLoader(false)
  }

  useEffect(() => {
    getPitStop()
  }, [])

  function renderLayout(){
    return (pitStop.length > 0 ? renderPitStop() : renderNoPitStop())
  }

  function renderPitStop() {
    return (
      <>
        <MobileMessage>We recomend turning your phone for better visualization of this page</MobileMessage>
        <Image src={ pitStop[0].img }></Image>
        <Message>IMPORTANT NOTE:<br/>The items shown after buying an item from the initial rotation are randomized for each player.</Message>
      </>
    )
  }
  
  function renderNoPitStop(){
    return (
      <NoPitStop>{ `Today's Pit Stop was not registered yet` }</NoPitStop>
    )
  }

  function renderLoader(){
    return(
      <Loader 
        type="Circles"
        color="#FFF"
        height="100"	
        width="100"
      />   
    )
  }

  return (
    <Layout selected="pitstop">
      <Container>
        { loader ? renderLoader() : renderLayout() }
      </Container>
    </Layout>
  )
  
}

export default PitStop